module.exports = __webpack_public_path__ + "static/media/quiz-hint-1-video-thumbnail.926112af.jpg";